<script setup>
import Highcharts from "highcharts";
import { watch, ref, onMounted } from "vue";

const props = defineProps({
  domId: String,
  title: String,
  categories: Array, // x-axis categories
  series: Array, // chart series data
  yAxisText: String, // y-axis label
});

const chartOptions = ref({
  chart: {
    type: "column",
  },
  title: {
    text: props.title,
  },
  xAxis: {
    categories: props.categories,
  },
  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: props.yAxisText,
    },
    stackLabels: {
      enabled: true,
    },
  },
  tooltip: {
    headerFormat: "<b>{point.x}</b><br/>",
    pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
  },
  plotOptions: {
    column: {
      stacking: "normal",
    },
  },
  series: props.series,
});

const chart = ref(null);

// ✅ Initialize chart once
onMounted(() => {
  chart.value = Highcharts.chart(props.domId, chartOptions.value);
});

// ✅ Update when props change
watch(
  () => [props.categories, props.series],
  ([newCategories, newSeries]) => {
    if (chart.value) {
      chart.value.update(
        {
          xAxis: { categories: newCategories },
          series: newSeries,
        },
        true, // redraw
        true, // one-to-one mapping
        false // no animation if you want
      );
    }
  },
  { deep: true, immediate: true } // 👈 ensures it runs immediately (even empty)
);
</script>

<template>
  <div :id="domId" style="height: 400px; width: 100%"></div>
</template>
